export enum RaceTypes {
  African = 1,
  Coloured = 2,
  Indian = 3,
  White = 4,
  NonRSA = 5
}

export enum Gender {
  Male = 1,
  Female = 2
}

export enum OccupationalLevelTypes {
  Executive_Director = 1,
  Non_Executive_Director = 2,
  Executive_Management = 3,
  Other_Executive_Management = 4,
  Senior_Management = 5,
  Middle_Management = 6,
  Junior_Management = 7,
  Semi_Skilled = 8,
  Unskilled = 9,
  Unspecified = 10,
  Not_A_Director = 11,
  Not_An_Employee = 12,
  Top_Management = 13
}

export enum MovementTypes {
  Recruitment = 1,
  Promotion = 2,
  Termination = 3
}

export enum ImportActions {
  NotSelected = -1,
  Append = 1,
  Overwrite = 2,
  UpdateAndReplaceYearToDateSpendValues = 3,
  UpdateAndAddSpendValuesToExistingTotalSpendValues = 4
};

export enum ScorecardTypes {
  None = 0,
  QSE_Scorecard_2013 = 3,
  Generic_Scorecard_2013 = 4,
  Generic_Scorecard_2013_Specialised = 5,
  Generic_Revised_Tourism_Sector_Code = 6,
  QSE_Revised_Tourism_Sector_Code = 7,
  Generic_Revised_MAC_Sector_Code = 8,
  QSE_Revised_MAC_Sector_Code = 9,
  QSE_Scorecard_2013_Specialised = 10,
  Generic_Revised_ICT_Sector_Code = 11,
  QSE_Revised_ICT_Sector_Code = 12,
  Generic_ICT_Sector_Code_Specialised = 13,
  Generic_Revised_Forest_Sector_Code = 14,
  QSE_Revised_Forest_Sector_Code = 15,
  Generic_Revised_Property_Sector_Code_Property_Owning = 16,
  Generic_Revised_Property_Sector_Code_All_Other_Companies = 17,
  Generic_Revised_MAC_Sector_Code_2018 = 18,
  QSE_Revised_MAC_Sector_Code_2018 = 19,
  Generic_Revised_Property_Sector_Code_Property_Managers_Services = 20,
  QSE_Revised_Property_Specialised_Sector_Code = 21,
  Generic_Revised_Construction_Sector_Code_Contractor = 22,
  Generic_Revised_Construction_Sector_Code_BEP = 23,
  QSE_Revised_Construction_Sector_Code = 24,
  Generic_Revised_FSC_Banks = 25,
  Generic_Revised_FSC_Life_Offices = 26,
  Generic_Revised_FSC_Short_Term_Insurers = 27,
  Generic_Revised_FSC_Stock_Exchanges_And_Members = 28,
  Generic_Revised_FSC_Other_Institutions = 29,
  Generic_Revised_Property_Sector_Code_Property_Owners_REITS_External_Management = 30,
  Generic_Revised_Agri_Sector_Code = 31,
  Generic_Revised_Property_Sector_Code_Specialised = 32,
  QSE_Revised_FSC = 33,
  QSE_Revised_Property_Sector_Code_Property_Owners_REITS_External_Management = 34,
  Generic_Revised_Transport_Codes_Public_Sub_Sector_Specialised_Scorecard = 35,
  Generic_Revised_Defence_Codes = 36,
  Generic_Revised_Transport_Codes_Road_Freight_And_Logistics_Sub_Sector = 37,
  Generic_Scorecard_2019 = 38,
  Generic_Revised_FSC_Specialised = 39,
  Revised_FSC_Sector_Codes_Retirement_Fund_Scorecard = 40,
  Revised_FSC_QSE_Specialised_Scorecard = 41,
  QSE_Revised_Agri_Sector_Code = 42,
  Employment_Equity = 43,
  BO_QSE_Scorecard = 44,
  MICT = 45,
  CHIETA = 46,
  merSETA = 47
};

export enum DataImportType {
  None = 0,
  EmployeeStructure = 1,
  BoardParticipation = 2,
  VerificationAgencyClient = 3,
  CombinedSkillsDevelopmentIndividual = 4,
  SkillsDevelopmentExternal = 5,
  SkillsDevelopmentInternal = 6,
  SkillsDevelopmentLAI = 7,
  PreferentialProcurement = 8,
  PreferentialProcurementExcludableImports = 9,
  IndividualSalary = 10,
  Ownership = 11,
  FinancialSupport = 12,
  DisposalOfAssets = 13,
  EconomicDevelopmentProgrammeContribution = 14,
  TotalMeasuredProcurementSpend = 15,
  EconomicDevelopmentInvestmentUnderResource = 16,
  GeneralInformation = 17,
  EquityEquivalent = 18,
  SocioEconomicDevelopment = 19,
  SkillsDevelopmentRelatedStaffSalaries = 20,
  PeopleManagement = 21,
  Company = 22,
  ScorecardSummary = 23,
  AffordableHousingFinancing = 24,
  AgriculturalFinancing = 25,
  TransactionFinancing = 26,
  TransformationalInfrastructureFinancing = 27,
  SkillsDevelopmentHEBursaries = 28,
  IntraGroupSpend = 29,
  EnterpriseDevContributions = 30,
  Product = 31,
  BlackOwnedSmallAndMedium = 32,
  BlackBusinessGrowthFunding = 33,
  SkillsDevelopmentLeviableAmount = 34,
  SupplierEarlyPayment = 35,
  EnterpriseEarlyPayment = 36,
  GeneralExpense = 37,
  SupplierDevContributions = 38,
  RSMContribution = 39,
  TrackTraineeReport = 40,
  UserTracking = 41,
  SupplierAnalysis = 42,
  SkillsDevelopmentMatrix = 43,
  EmploymentEquityEmployeeStructure = 44,
  Person = 45,
  Salary = 46,
  Individual = 47,
  EESalary = 48,
  CertificateRegistry = 49,
  ProductPolicy = 50,
  ShortTermInsurersProductPolicy = 51,
  AccessToFinancialServicesShortTerm = 52,
  JobTitle = 53,
  PlatformPeople = 54,
  WorkforceProfileReport = 55,
  PlatformSalary = 56,
  MerSetaTraining = 57, 
  MerSETAReport = 58,
  EEWorkforceProfile = 59,
  UserManagement = 60,
  EEPlanWorkforceProfile = 61,
  EEIndividualGroupImport = 62,
  EESalaryGroupImport  = 63,
  ScorecardUserAccess = 64,
  UserRoles = 65
};

export enum ModuleType {
  BEE_Module = 1,
  Employment_Equity_Module = 2,
  WSP_Module = 3,
};

export enum LegislationSections {
  EmploymentEquityAct = 1,
  CodesOfGoodPractice = 2,
  TechnicalAssistanceGuidelines = 3,
  BBBEE = 4,
  CHARTERS = 5,
  Media_Releases = 6,
  Newsletters = 7,
  Templates = 8,
  Verification = 9,
  Practice_Guides = 10,
  Notices = 11,
  Legislative_Mandate = 12,
  MerSETA_Documents = 13,
  MerSETA_Templates = 14,
  EEForms = 15,
  EETemplates = 16,
  Reports = 17,
  OtherRelevantActs = 18
};

export enum SetaClassification {
  AgriSETA = 1,
  BANKSETA = 2,
  CHIETA = 3,
  CETA = 4,
  CATHSSETA = 5,
  ETDP_SETA = 6,
  EWSETA = 7,
  FPandM_SETA = 8,
  Fasset = 9,
  FoodBev_SETA = 10,
  HWSETA = 11,
  Inseta = 12,
  LGSETA = 13,
  merSETA = 14,
  MICT_SETA = 15,
  MQA = 16,
  PSETA = 17,
  SASSETA = 18,
  SSETA = 19,
  TETA = 20,
  WandRSETA = 21
}
export enum RemunerationType {
  High = 1,
  Low = 2,
  Average = 3,
  Median = 4
}

export enum VerificationCompanyType {
  Sole_Proprietor = 1,
  Close_Corporation = 2,
  Pty_Ltd = 3,
  Trust = 4,
  Joint_Venture = 5,
  Limited = 6,
  Branch_of_Foreign_listed_company = 7,
  Non_Profit_Company = 8,
  Incorporated = 9,
  NGO_SOC_Agency = 10,
}

export enum VAExcelExportStatus {
    InProgress = 0,
    Completed = 1,
    Failed = 2
}

export enum VerificationProcessStatus {
  "Planned" = 1,
  "In Progress" = 2,
  "Completed" = 3,
}

export enum VaCertificateRegistryScorecardSpecificFields {
  Ownership = 1,
  Employment_Equity = 2,
  Management_Control = 3,
  Skills_Development = 4,
  Socio_Economic_Development = 5,
  RSM_Contributions = 6,
  Economic_Development = 7,
  Preferential_Procurement = 8,
  Preferential_Procurement_and_Supplier_Development = 9,
  Empowerment_Financing_and_ESD = 10,
  Access_to_Financial_Services = 11,
  Localisation = 12,
  Supplier_Development = 13,
  Enterprise_Development = 14,
  Enterprise_and_Supplier_Development = 15
}

export enum UserType {
  User = 1,
  SubAdmin = 2,
  Admin = 3
}

export enum VAUserType {
  Analyst = 1,
  TechnicalSignatory = 2,
  InternalAuditor = 3,
  Client = 4
}

export enum VAElements {
  "Ownership" = 1,
  "Board Participation" = 2,
  "Employee Structure" = 3,
  "Skills Development - Expenditure" = 4,
  "Skills Development - Headcount" = 5,
  "Preferential Procurement" = 6,
  "Enterprise Development" = 7,
  "Supplier Development" = 8,
  "Socio-Economic Development" = 9,
  "Sector Specific Elements" = 10,
  "Access to Financial Services" = 11,
  "Empowerment Financing" = 12,
  "RSM" = 13,
  "Localisation" = 14,
  "Economic Development" = 15
}

export enum SettingType {
  FieldNames = 1
}

export enum DocumentRepoSectionModuleTypes {
  BEE_Module = 1,
  EE_Module = 2,
  Verificaion_Agency = 3
}

export enum Months {
  "January" = 1,
  "February" = 2,
  "March" = 3,
  "April" = 4,
  "May" = 5,
  "June" = 6,
  "July" = 7,
  "August" = 8,
  "September" = 9,
  "October" = 10,
  "November" = 11,
  "December" = 12
}

export enum VaIntegrationStatus {
  Pending = 1,
  Accepted = 2,
  Rejected = 3
}

export enum Service {
  BBBEEVerification = 1,
  GapReview = 2,
  OwnershipReview = 3,
  Opinion = 4,
  JointVenture = 5,
  Training = 6,
  SEDBeneficiaryCertificate = 8,
  OwnershipCertificate = 9,
  ReEvaluationOfElements = 10
}

export enum ScorecardTypeCategory {
  EME = 1,
  QSE = 2,
  SpecialQSE = 3,
  ConsolidatedQSE = 4,
  Generic = 5,
  SpecialisedGeneric = 6,
  ConsolidatedGeneric = 7,
  JointVentureQSE = 8,
  JointVenture = 9
}

export enum OwnershipStructureElement {
  NaturalPerson = 1,
  Company = 2,
  CompanyWithBBBEE = 3,
  BroadBasedOwnershipScheme = 4,
  EmployeeShareOwnershipProgram = 5,
  Trust = 6,
  SaleOfAssets = 7
}

export enum SectorCode {
  NotApplicable = 0,
  ICT = 1,
  TransportBusCommuterAndCoach = 2,
  FSCBanks = 3,
  MAC = 4,
  Security = 5,
  Forest = 6,
  Agri = 7,
  Tourism = 8,
  DTI = 9,
  PropertyAllOtherCompanies = 10,
  ConstructionBEP = 11,
  Defence = 12,
  ConstructionContractor = 13,
  TransportDomesticAviation = 14,
  TransportForwardingAndClearing = 15,
  TransportMaritime = 16,
  TransportPublicDOT = 17,
  TransportPublicSOE = 18,
  TransportRail = 19,
  TransportRoadFreight = 20,
  TransportTaxiOwners = 21,
  FSCLifeOffices = 22,
  FSCOtherInstitutions = 23,
  FSCShortTermInsurers = 24,
  FSCStockExchange = 25,
  FSCRetirementFund = 26,
  FSCTradeAssociationSpecialisedEnterprises = 27,
  PropertyEstateAgents = 28,
  PropertyPropertyOwning = 29,
  PropertyPropertyAndAssetManagers = 30,
  PropertyAPUTSPropertyUnitTrusts = 31,
  PropertyOwnersAndREITSExternal = 32,
  PropertyPLSALoansStockExternal = 33,
  PropertyPLSAandREITSInternal = 34,
  PropertyUnlistedMandatedCollectiveInvestmentSchemes = 35,
  PropertySpecializedEntities = 36,
  TransportTaxiAssociation = 37
}

export enum AutomatedNotificationType {
  Application_Status_Tracker = 1,
  Scorecard_Planner_And_Tracker = 2,
}

export enum ScorecardElements {
  "General Information" = 1,
  "People" = 2,
  "Ownership" = 3,
  "Management Control" = 4,
  "Skills Development" = 5,
  "Enterprise And Supplier Development" = 6,
  "Socio-Economic Development" = 7,
  "Employment Equity" = 8,
  "Preferential Procurement" = 9,
  "Preferential Procurement And Supplier Development" = 10,
  "Empowering Financing And ESD" = 11,
  "Access To Financial Services" = 12,
  "Economic Development" = 13,
  "RSM" = 14,
  "Localisation" = 15,
  "Y.E.S. Initiative" = 16,
  "Empowering Supplier" = 17
}

export enum ScorecardDataPages {
  "General" = 1,
  "People Database" = 2,
  "People Salaries" = 3,
  "Ownership Details" = 4,
  "Equity Equivalent" = 5,
  "Financial Support" = 6,
  "Disposal Of Assests" = 7,
  "Board Participation" = 8,
  "Employee Structure" = 9,
  "General Information" = 10,
  "External Skills Development" = 11,
  "Internal Skills Development" = 12,
  "LAIs" = 13,
  "Related Staff Salaries" = 14,
  "General Expenses" = 15,
  "Ancillary Costs Summary" = 16,
  "Skills Development Summary" = 17,
  "Combined SD Expenditure Per Person" = 18,
  "Higher Education Bursaries" = 19,
  "Procurement" = 20,
  "Total Measured Procurement Spend" = 21,
  "Enterprise Development" = 22,
  "Supplier Development Contributions" = 23,
  "Supplier Development Early Payments" = 24,
  "Transformational Infrastructure" = 25,
  "Affordable Housing" = 26,
  "B-BBEE Agriculture Financing" = 27,
  "B-BBEE Transaction Financing" = 28,
  "Black Business Growth Funding" = 29,
  "Black Owned SMEs Financing" = 30,
  "Socio Economic Development" = 31,
  "Products" = 32,
  "Policies" = 33,
  "Short Term" = 34,
  "RSM" = 35,
  "Investment Under Resourced Area" = 36,
  "Programme Contributions" = 37,
  "Localisation" = 38,
  "Y.E.S. Initiative" = 39,
  "Empowering Supplier" = 40,
  "Management Control People Database" = 41
}

export enum VaSubmissionTypes {
  Submit_for_Verification = 1,
  Request_Access = 2,
}

export enum ActionTypes {
  First_Submission = 1,
  Resubmission = 2,
  Reevaluation = 3,
  Reject = 4
}

export enum DataPageSubmissionStatus {
  Pending = 1,
  Accepted = 2,
  Rejected = 3,
  Abandoned = 4
}

export enum SubmissionTrackerStatus {
  'Planned' = 0,
  'Submitted, pending VA action' = 1,
  'Submission accepted' = 2,
  'Submission rejected' = 3,
  'Requested to edit, pending VA action' = 4,
  'Request to edit accepted - Re-submission' = 5,
  'Request to edit accepted - Re-evaluation' = 6,
  'Request to edit rejected' = 7,
  'Abandoned' = 8
}

export enum VerificationStatus {
  'Planned' = 1,
  'In Progress' = 2,
  'Completed' = 3
}

export enum VaProcessReminderState {
  NotStored = 0,
  RemindMeLater = 1,
  Dismissed = 2
}

export enum TrainingTypes {
  LAI = 1,
  External = 2,
  Internal = 3
}

export enum EmployeeTypes {
  Employee = 1,
  Employed_By_Other = 2,
  Unemployed = 3,
  Employee_Previously_Unemployed = 4,
  Invalid_Employee_Type = 5
}

export enum WSPATRReportType {
  ATR = 1,
  WSP = 2
}

export enum NotificationTriggerType {
  StatusChangePlanner = 1,
  ScheduledDate = 2,
  StatusChangeApplicationTracker = 3,
  DaysElapsed = 4,
}

export enum DeviationReason {
  InsufficientRecruitmentOpportunities = 1,
  InsufficientPromotionOpportunities = 2,
  InsufficientTargetIndividuals = 3,
  CCMA = 4,
  TransferOfBusiness = 5,
  MergersOrAcquisitions = 6,
  ImpactOnBusiness = 7
}

export enum UserActivityActionType
{
  'Create' = 0,
  'Update' = 1,
  'Delete' = 2,
  'Link' = 3,
  'Populate To Scorecard' = 4,
  'Lock Scorecard' = 5,
  'Download' = 6,
  'Generate' = 7,
  'Upload' = 8,
  'Reconsolidate' = 9,
  'Regenerate' = 10,
  'Import' = 11,
  'Export' = 12,
  'Login' = 13,
  'Email' = 14,
  'Logout' = 15,
  'User Management' = 16,
  'View' = 17
}

export enum EEAReportType
{
  EEA2 = 1,
  EEA4 = 2,
  EEA12 = 3,
  EEA13 = 4
}